import React from 'react';
import FadeIn from '../common/FadeIn';
import about3 from '../../assets/images/about3.png';

const AboutMoreThanSection = () => {
  return (
    <section className="w-full bg-[#0A0A0A] text-white sticky top-0 z-30 min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-stretch min-h-screen">

        <FadeIn className="w-full h-full min-h-[380px] sm:min-h-[480px] lg:min-h-full self-stretch bg-[#1A1D20] flex items-center justify-center relative overflow-hidden">
          <img
            src={about3}
            alt="Princy Patel - Custom Website Design & Digital Showcase"
            className="w-full h-full object-cover object-center"
            loading="lazy"
            decoding="async"
            width="600"
            height="800"
          />
        </FadeIn>

        <div className="w-full bg-[#0A0A0A] flex flex-col justify-center p-8 sm:p-12 md:p-16 lg:p-20">
          <div className="max-w-[540px] mx-auto lg:mx-0">
            <FadeIn>
              <h2 className="font-saolDisplayItalic md:text-[70px] text-[40px] leading-[1] font-normal tracking-[0em] mb-7 sm:mb-9">
                More Than a Website
              </h2>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-white leading-[1.6] tracking-[0em] mb-6">
                Getting a website doesn't have to be complicated.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-white leading-[1.6] tracking-[0em] mb-6">
                I handle the design changes, content, layout, and final details so you have a website that looks good and is easy for your clients to use.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-white leading-[1.6] tracking-[0em] mb-6">
                Simple, practical, and made for your business.
              </p>
            </FadeIn>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutMoreThanSection;
